import "core-js/modules/es.number.constructor.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Loader from "../Loader.vue";
import ProgressBar from "../progress-bar/ProgressBar.vue";
export default {
  components: {
    Loader: Loader,
    ProgressBar: ProgressBar
  },
  props: {
    title: {
      type: String,
      required: true
    },
    loading: {
      type: Boolean,
      required: false
    },
    progress: {
      type: Number,
      required: false
    },
    hasProgress: {
      type: Boolean,
      required: false,
      default: true
    },
    size: {
      type: String,
      required: false
    },
    className: {
      type: String,
      required: false
    }
  },
  methods: {
    confirm: function confirm() {
      if (this.loading) return;
      this.$emit("confirm");
    },
    cancel: function cancel() {
      this.$emit("cancelUpload");
    }
  }
};